/**
 * Current-admin settings (`PATCH /admin`).
 */
import Api from "@/api/Api";

export default {
  update(data) {
    return Api().patch("/admin", data);
  },
};
